import React from 'react';
import PropTypes from 'prop-types';

import { PrsDefaultButton } from '../../../../styles-and-themes/styles/prsButtons';
import { composeDestinationQuerystring } from '../../../../../shared-with-server/destination-utils';
import { destinationInfo } from '../../../../destructured-front-end-config';
import { ButtonsContainer, ForgotPasswordLink } from './LoginForgotControlSetStyles';

const LoginForgotControlSet = ({ onLogin, isFormValid, destPath }) => (
  <ButtonsContainer>
    <PrsDefaultButton className="login-button" onClick={onLogin} disabled={!isFormValid}>Next</PrsDefaultButton>

    <ForgotPasswordLink href={`/ForgotPassword?${composeDestinationQuerystring(destinationInfo, destPath)}`} title="Forgot your password?" style={{ fontSize: '16px' }}>
      Forgot Password?
    </ForgotPasswordLink>
  </ButtonsContainer>
);

LoginForgotControlSet.propTypes = {
  onLogin: PropTypes.func.isRequired,
  isFormValid: PropTypes.bool.isRequired,
  destPath: PropTypes.shape({
    dest: PropTypes.string,
    path: PropTypes.string,
    retURL: PropTypes.string,
  }).isRequired,
};

export default LoginForgotControlSet;
